<template>
  <div>
    <TagItem
      v-for="(tag) in store.state.tags"
      :key="tag.id"
      :model="tag"
      class="mt-1 mb-1 mr-2"
      @removeTag="removeTag"
    />

    <SearchTermItem
      v-for="(term) in store.state.searchTerms"
      :key="term"
      :model="term"
      class="mt-1 mb-1 mr-2"
      @removeTerm="removeSearchTerm"
    />
  </div>
</template>

<script>
import tracking from '@/helpers/tracking'
import pageRefresh from '@/components/facet/page-refresh'
import TagItem from '@/components/facet/TagItem.vue'
import SearchTermItem from '@/components/facet/SearchTermItem.vue'
import store from '@/components/facet/store'

export default {
  components: {
    SearchTermItem,
    TagItem
  },
  data() {
    return {
      store
    }
  },
  methods: {
    async removeSearchTerm(searchTerm) {
      const { currentTagsAndTerms: currentFilters } = this.store.getters
      tracking.removeFilter({
        currentFilters,
        placement: 'hero filters',
        filterName: searchTerm
      })
      this.store.dispatch('removeSearchTerm', { searchTerm })
      pageRefresh.updatePage()
    },
    async removeTag(tag) {
      const { currentTagsAndTerms: currentFilters } = this.store.getters
      tracking.removeFilter({
        currentFilters,
        placement: 'hero filters',
        filterName: tag.name
      })
      this.store.dispatch('removeTag', { tag })
      pageRefresh.updatePage()
    }
  }
}
</script>
